import {Directive, Output, EventEmitter, ElementRef, HostListener, OnDestroy, Input} from '@angular/core';
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appClickAndHold]',
})
export class ClickAndHoldDirective {
  @Input() intervalSpeed = 100;
  @Output() clickAndHold = new EventEmitter();

  private interval: any;

  @HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent) {
    this.interval = setInterval(() => {
      this.clickAndHold.emit();
    }, this.intervalSpeed);
  }

  @HostListener('mouseleave') onMouseLeave() {
    clearInterval(this.interval);
  }

  @HostListener('mouseup') onMouseUp() {
    clearInterval(this.interval);
  }
}
